module.exports = __webpack_public_path__ + "img/open.22ebee1e.png";